export interface IRole {
  id: string;
  name: string;
  description: any;
  target: number;
  entityId: string;
  permissions: string[];
}
